import Vue from "vue";
import VueRouter from "vue-router";

// import routes from "./routes";
import routeRouting from "vue-auto-routing";
// import { createRouterLayout } from "vue-router-layout";
import MainLayout from "src/layouts/default";
Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */
// Create <RouterLayout> component.
// const RouterLayout = createRouterLayout((layout) => {
// 	// Resolves a layout component with layout type string.
// 	return import("layouts/" + layout + ".vue");
// });
export default async function (/*{ store, ssrContext }*/) {
  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
  };
  let router = [];
  const routes = [];
  const filter = (ele = routeRouting) => {
    return ele
      .filter((item) => {
        return (
          item.path.indexOf("components") == -1 &&
          item.path.indexOf("modules") == -1
        );
      })
      .map((i) => {
        // Object.assign 方法用于将所有可枚举属性的值从一个或多个源对象复制到目标对象。它将返回目标对象
        // 如果目标对象中的属性具有相同的键，则属性将被源对象中的属性覆盖。后面的源对象的属性将类似地覆盖前面的源对象的属性
        i = Object.assign({}, i);
        if (!!i.children) {
          i.children = filter(i.children);
        }
        return i;
      });
  };
  router = filter();
  router.forEach((item) => {
    routes.push({
      path: "/",
      component: () =>
        item.layout
          ? import("layouts/" + item.layout + ".vue")
          : import("layouts/default.vue"),
      children: [item],
    });
  });
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes: [
      ...routes,
      {
        path: "*",
        component: MainLayout,
        children: [
          {
            path: "",
            component: () => import("src/layouts/404.vue"),
          },
        ],
      },
    ],
    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
  });
  return Router;
}
